module.exports = __webpack_public_path__ + "img/08-4中图.a2ca4c10.png";